var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { CustomElement, Watch, P, Utils } from '@pacem/pacem-core';
import { PresentationElement } from './types';
import { TAG_MIDDLE_NAME } from './constants';
import { DrawableElement } from './drawable-element';
//namespace Pacem.Components.Drawing {
let PacemGroupElement = class PacemGroupElement extends PresentationElement {
    validate(item) {
        return item instanceof DrawableElement && item.parent === this;
    }
    #children = [];
    get childDrawables() {
        return this.#children;
    }
    propertyChangedCallback(name, old, val, first) {
        super.propertyChangedCallback(name, old, val, first);
        switch (name) {
            case 'items':
            case 'datasource':
                this.#children = (val || []);
                const scene = this.stage;
                if (!Utils.isNull(scene)) {
                    scene.draw(this, true);
                }
                break;
        }
    }
};
__decorate([
    Watch({ emit: false })
], PacemGroupElement.prototype, "datasource", void 0);
PacemGroupElement = __decorate([
    CustomElement({ tagName: P + '-' + TAG_MIDDLE_NAME + '-group' })
], PacemGroupElement);
export { PacemGroupElement };
